@if (text$()) {
  @if (icon$()) {
    <div class="sol-alert-icon">
      <sol-icon [name]="icon$()" />
    </div>
  }
  <div class="sol-alert-text" [class.sol-alert-text-truncated]="truncated$()">
    @if (!custom$()) {
      {{ text$() | translate }}
    } @else {
      <ng-content></ng-content>
    }
    @if (info$()) {
      <div class="sol-alert-info">{{ info$() | translate }}</div>
    }
  </div>
}
